import * as angular from 'angular';
import { formatDistance } from 'date-fns';

class ReportRunButtonController {
  static $inject = ['RxStoreService'];

  public manualRunDisabled: boolean;
  public expectedRuntime: number;
  public disabled: boolean;
  public onRunClick: () => void;

  constructor() {}

  runButtonTooltipText(isEnabled: boolean): string {
    if (isEnabled) {
      return 'Usually finishes in ' + formatDistance(this.expectedRuntime * 1000, 0, { includeSeconds: true });
    } else {
      return 'Running this report has been disabled. It will \n continue to run on a schedule.';
    }
  }

  handleRunClick(isEnabled: boolean) {
    if (isEnabled) {
      this.onRunClick();

      // Disable button after first click to prevent re-sending report params
      this.disabled = true;
    }
  }
}

const reportRunButtonComponent: angular.IComponentOptions = {
  bindings: {
    disabled: '<',
    expectedRuntime: '<',
    classes: '@',
    onRunClick: '&',
  },
  template: `
    <capra-tooltip
      tooltip-content="{{ ctrl.runButtonTooltipText(!ctrl.disabled) }}"
      tooltip-placement="bottom-end"
      tooltip-size="mini">
      <capra-button
        class="{{ ctrl.classes }}"
        data-test="parameter-run-button"
        text="Run"
        size="small"
        [disabled]="ctrl.disabled"
        (clicked)="ctrl.handleRunClick(!ctrl.disabled)">
      </capra-button>
    </capra-tooltip>
  `,
  controller: ReportRunButtonController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('reportRunButton', reportRunButtonComponent);
